(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/legal-info/assets/javascripts/init-login-check.js') >= 0) return;  svs.modules.push('/modules/legal-info/assets/javascripts/init-login-check.js');

'use strict';

const {
  ErrorBoundary
} = svs.components.errorBoundary;
const LoginCheck = svs.legal_info.components.login_check.LoginCheck;
ReactDOM.render(React.createElement(ErrorBoundary, null, React.createElement(LoginCheck, null)), document.getElementsByClassName('js-react-container')[0]);

 })(window);